import { authHeader } from "../helpers";

export const taskService = {
  exportPdf,
  exportXls,
};

function exportPdf(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: data,
    responseType: "blob",
  };
  return fetch(process.env.VUE_APP_API_URL + "/task/exportPdf", requestOptions)
    .then((response) => response.blob())
    .then((blobTxt) => {
      var blob = new Blob([blobTxt], { type: "application/pdf" });
      var win = window.open("", "_blank");
      var URL = window.URL || window.webkitURL;
      var dataUrl = URL.createObjectURL(blob);
      win.location = dataUrl;

      return true;
    });
}

function exportXls(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: data,
    responseType: "blob",
  };
  return fetch(process.env.VUE_APP_API_URL + "/task/exportXls", requestOptions)
    .then((response) => response.blob())
    .then((blobTxt) => {
      var blob = new Blob([blobTxt], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var win = window.open("", "_blank");
      var URL = window.URL || window.webkitURL;
      var dataUrl = URL.createObjectURL(blob);
      win.location = dataUrl;

      return true;
    });
}
